// 🩹 PARCHE TEMPORAL PARA URLs DE IMÁGENES
const fixImageUrl = (imageUrl) => {
  if (!imageUrl || typeof imageUrl !== "string") {
    return imageUrl;
  }

  // Reemplazar dominio incorrecto por el correcto
  if (
    imageUrl.includes("staging-exports-web.s3.amazonaws.com") ||
    imageUrl.includes("tattersall-backup.s3.amazonaws.com")
  ) {
    const correctedUrl = imageUrl.includes(
      "staging-exports-web.s3.amazonaws.com"
    )
      ? imageUrl.replace(
          "staging-exports-web.s3.amazonaws.com",
          "production-website-images.s3.amazonaws.com"
        )
      : imageUrl.replace(
          "tattersall-backup.s3.amazonaws.com",
          "production-website-images.s3.amazonaws.com"
        );

    console.log("🩹 Image URL patched in ProductDetail:", {
      original: imageUrl,
      corrected: correctedUrl,
    });

    return correctedUrl;
  }

  return imageUrl;
};

const fixProductImages = (images) => {
  if (!Array.isArray(images)) {
    return images;
  }
  return images.map(fixImageUrl);
};

export { fixImageUrl, fixProductImages };
